import React from 'react';
import {Link} from 'react-router-dom';

import {translate} from 'iss/strings';
import {translateEvaluationType, translateEventState} from 'iss/widgets/domainTranslations';
import {SelectableTable} from 'iss/widgets/SelectableTable';
import {Table} from 'iss/widgets/bootstrap/Table';
import {formatSiteAddress} from 'iss/widgets/format/Site';
import {SortColumnHeader} from 'iss/widgets/SortColumnHeader';

export function LateEventsList({events, selectable = false, compact = false, extraColumns = [], onChangeSort, ...props}) {
  const TableComponent = selectable ? SelectableTable : Table;
  const columns = compact ? compactColumns : defaultColumns(onChangeSort);
  return <TableComponent id="late-events-list" data={events}
    {...props}
    columns={extraColumns.length > 0 ? [...columns, ...extraColumns] : columns}
  />;
}

function HeaderButtons(text, field, onChangeSort) {
  return <SortColumnHeader text={text} field={field} onChangeSort={(field, order) => onChangeSort({sortFieldName: field, sortOrder: order})}/>;
}

const defaultColumns = (onChangeSort) => {
  const result = [
    {
      header: translate('domain.evaluationEvent.eventId'),
      cellProps: {className: "event-id" },
      accessor: e => e.id
    }, {
      header: HeaderButtons('domain.evaluationEvent.activationId', 'ACTIVATION_ID', onChangeSort),
      cellProps: {className: "event-activation-id" },
      accessor: e => e.activationId
    }, {
      header: HeaderButtons('domain.activatedEvaluation.evaluationType', 'EVALUATION_TYPE', onChangeSort),
      cellProps: {className: "event-evaluation-type" },
      accessor: e => translateEvaluationType(e.evaluationType)
    }, {
      header: HeaderButtons('domain.evaluationEvent.site', 'SITE_NAME', onChangeSort),
      cellProps: {className: "event-site" },
      accessor: e => e.site == null ? "" : <Link to={"/activatedEvaluations/"+e.activationId}>{e.site.name} {formatSiteAddress(e.site)}</Link>
    }, {
      header: HeaderButtons('domain.evaluationEvent.formName', 'FORM_NAME', onChangeSort),
      cellProps: {className: "event-form-name" },
      accessor: e => e.formName
    }, {
      header: HeaderButtons('domain.evaluationEvent.state', 'STATE', onChangeSort),
      cellProps: {className: "event-state" },
      accessor: e => translateEventState(e.state)
    }, {
      header: HeaderButtons('domain.evaluationEvent.plannedDate', 'PLANNED_DATE', onChangeSort),
      cellProps: {className: "event-planned-date" },
      accessor: e => e.plannedDate
    },
    {
      header: HeaderButtons('domain.evaluationEvent.siteCoordinator', 'SITE_COORDINATOR', onChangeSort),
      cellProps: {className: "event-site-coordinator" },
      accessor: getSiteCoordinator
    }
  ];

  return result;
};

function getSiteCoordinator(e) {

  if (e.siteCoordinators && e.siteCoordinators.length > 0) {
    const party = e.siteCoordinators[0];
    return `${party.lastname}, ${party.firstname}`;
  } else {
    return '';
  }
}

const compactColumns = [
  {
    header: translate('domain.evaluationEvent.eventId'),
    cellProps: {className: "event-id" },
    accessor: e => e.id
  }, {
    header: translate('domain.evaluationEvent.activationId'),
    cellProps: {className: "event-activation-id" },
    accessor: e => e.activationId
  }, {
    header: translate('domain.evaluationEvent.site'),
    cellProps: {className: "event-site" },
    accessor: e => <Link to={"/activatedEvaluations/"+e.activationId}>{e.site.name} {formatSiteAddress(e.site)}</Link>
  }, {
    header: translate('domain.evaluationEvent.plannedDate'),
    cellProps: {className: "event-planned-date" },
    accessor: e => e.plannedDate
  },
];



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/LateEventsList.jsx